const theme = {
  colors: {
    primary: '#52357B',         // A vibrant purple
    secondary: '#8F87F1',       // A lighter, softer purple/blue
    primaryDark: '#B17DDD',     // A slightly darker shade of primary for hover states
    secondaryDark: '#7A72E0',   // A slightly darker shade of secondary for hover states
    backgroundLight: '#ffffff', // Keep white background for components
    textDark: '#333',           // Dark text for readability
    textLight: '#f8f9fa',       // Light text (e.g., for buttons)
    textDarkBlue: '#2C3E50',
    error: '#dc3545',           // Standard error red
    success: '#28a745',         // Standard success green
  },
  fonts: {
    main: 'Roboto, sans-serif',
  },
  spacing: {
    small: '8px',
    medium: '16px',
    large: '24px',
    xLarge: '32px',
  },
  borderRadius: '8px',
  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
};

export default theme;

